<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">{{ $t("navigation.administrators") }}</h2>
    </div>

    <administrators-list />

    <add-btn @onClick="toggleModal" />

    <modal :show="show" :outside="false" :dark="true" @close="toggleModal">
      <administrators-modal />
    </modal>

    <modal
      :show="deleteModal"
      :showBtn="false"
      :outside="false"
      :dark="true"
      @close="toggleDeleteModal"
    >
      <delete-modal
        :title="$t('administrators.deleteTitle').toString()"
        @cancel="toggleDeleteModal"
        @next="removeAction"
      />
    </modal>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'

import administratorsList from '@/components/lists/administrators/administratorsList'
import administratorsModal from '@/components/modals/administrators/administratorsModal'
import addBtn from '@/components/controls/addBtn'

export default {
    components: {
        administratorsList,
        administratorsModal,
        addBtn,
    },
    computed: {
        ...mapGetters({
            show: 'administrators/showGetters',
            deleteModal: 'administrators/deleteModalGetters',
        }),
    },
    methods: {
        ...mapMutations({
            toggleModal: 'administrators/toggleModal',
            toggleDeleteModal: 'administrators/toggleDeleteModal',
        }),
        ...mapActions({
            remove: 'administrators/remove',
        }),
        removeAction() {
            this.remove()
        },
    },
    beforeDestroy() {
        if (this.show) {
            this.toggleModal()
        }
    },
}
</script>

<style>
.administrators__add .modal__body {
  height: 70vh;
}
</style>
